import { motion } from "framer-motion";
import { GLASS } from "@/lib/glass";

// Fixed radial void: pure #000 at the viewport edges, the ambient light field breathing through the center.
export const VoidVignette = () => (
  <div
    aria-hidden="true"
    data-testid="void-vignette"
    className="void-vignette pointer-events-none fixed inset-0 z-[-2]"
  />
);

// The subconscious threshold: a 1px gold line between the Hero and The Passage.
export const SubconsciousThreshold = () => (
  <div data-testid="hero-passage-threshold" aria-hidden="true" className="relative z-[1] w-full">
    <motion.span
      initial={{ opacity: 0, scaleX: 0.18 }}
      whileInView={{ opacity: 1, scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.9, ease: GLASS.settle }}
      className="subconscious-threshold block w-full origin-center"
    />
  </div>
);
